export const EXCMUSERDATAWORKPLACE_SHOW_RESET = 'EXCMUSERDATAWORKPLACE_SHOW_RESET'
export const EXCMUSERDATAWORKPLACE_SHOW_SET_ERROR = 'EXCMUSERDATAWORKPLACE_SHOW_SET_ERROR'
export const EXCMUSERDATAWORKPLACE_SHOW_SET_RETRIEVED = 'EXCMUSERDATAWORKPLACE_SHOW_SET_RETRIEVED'
export const EXCMUSERDATAWORKPLACE_SHOW_TOGGLE_LOADING = 'EXCMUSERDATAWORKPLACE_SHOW_TOGGLE_LOADING'
